import React, { useCallback, useRef } from 'react'
import { styled, SxProps } from '@mui/material/styles'
import { IconButton, ButtonBase } from '@mui/material'
import RemoveCircleFillIcon from '@mui/icons-material/RemoveCircleOutline'
import { ImageIcon } from '@/icon'
import img_icon from '@/asset/img/img_icon.webp'
import { useMutation } from '@tanstack/react-query'

const UploaderWrapper = styled('div')(() => ({
  display: 'flex',
  gap: '8px',
  flexWrap: 'wrap',
}))

const FileInput = styled('input')(() => ({
  display: 'none',
}))

const FileInputComponent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '40px',
  height: '40px',
  cursor: 'pointer',
  border: '1px solid #f2f2f2',
  padding: '4px',
}))

const IconWrapper = styled('div')(() => ({
  position: 'absolute',
  //   marginLeft: "5px",
  marginTop: '-14px',
  display: 'flex',
  width: '42px',
  justifyContent: 'flex-end',
}))

const ImgDisplay = styled(ButtonBase)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
}))

export interface UploaderProps {
  max?: number;
  value?: string[];
  error?: boolean;
  onChange?: (value: string[]) => void;
  onUpload?: (value: File) => Promise<{ paths: string }>;
  sx?: SxProps;
}

const Uploader: React.FC<UploaderProps> = (props) => {
  const { value = [], onChange, max, onUpload, sx } = props
  const inputRef = useRef(null)

     // @ts-ignore
  const uploadMutation = useMutation(onUpload, {
    onSuccess: (res) => {
      const url = res?.paths
      const urls = [...value]
      urls.push(url)
      onChange && onChange([...urls])
    },
  })

  const handleClick = useCallback(() => {
    if (inputRef?.current) {
         // @ts-ignore
      inputRef?.current?.click()
    }
  }, [])

  const handleFileChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = event.target
         // @ts-ignore
      uploadMutation.mutate(files[0])
    },
    [uploadMutation]
  )

  const handleRemoveFile = useCallback(
    (index: number) => () => {
      const urls = [...value]
      urls.splice(index, 1)
      onChange && onChange([...urls])
    },
    [onChange, value]
  )

  return (
    <UploaderWrapper sx={sx}>
      {value &&
        value?.map((fileUrl, index) => (
          <FileInputComponent sx={{ cursor: 'default' }} key={`img-${index}`}>
            <IconWrapper>
              <IconButton
                onClick={handleRemoveFile(index)}
                sx={{ padding: '4px' }}
              >
                <RemoveCircleFillIcon sx={{ fontSize: '14px' }} />
              </IconButton>
            </IconWrapper>
            <div style={{ flex: 1, width: '100%', height: '100%' }}>
              <img
                style={{ objectFit: 'contain', width: '100%', height: '100%' }}
                src={fileUrl}
              />
            </div>
          </FileInputComponent>
        ))}
      <FileInputComponent
        sx={{
             // @ts-ignore
          display: !(value?.length < max) ? 'none' : 'default',
          border: 'none',
          marginTop: 'auto',
          height: 'auto',
          width: 'auto',
        }}
      >
        <ImgDisplay onClick={handleClick}>
          <ImageIcon src={img_icon} />
        </ImgDisplay>
        <FileInput
          ref={inputRef}
          type="file"
          accept="image/*"
          multiple={false}
          value={''}
          onChange={handleFileChange}
        />
      </FileInputComponent>
    </UploaderWrapper>
  )
}

export default Uploader
